import type { ImportedReceipt } from "../Purchases/types";
import type { InvoiceDraft } from "../Invoices/types";
import type { OrderDraft } from "../Orders/types";
import type { ScanResult } from "./types";

// A scan opens as a delivery, an invoice or an order; each editor takes its
// own draft shape.

export const scanToReceipt = (r: ScanResult): ImportedReceipt => ({
  ...r.match,
  received_at: r.document.delivery_date ?? r.match.received_at,
  document_key: r.document_key,
  source: "scan",
});

export const scanToInvoice = (r: ScanResult): InvoiceDraft => ({
  supplier_id: r.match.supplier_id,
  invoice_number: r.document.document_number,
  issue_date: r.document.issue_date,
  due_date: r.document.due_date,
  currency: r.document.currency,
  net_amount: r.document.net_total,
  vat_amount: r.document.vat_total,
  total: r.document.total,
  document_key: r.document_key,
  lines: r.match.lines.map((l, i) => ({
    description: l.description,
    supplier_code: l.supplier_code,
    quantity: l.quantity,
    unit: l.unit,
    unit_price: l.unit_price,
    vat_rate: r.document.vat_rates[i] ?? null,
    line_total: l.line_total,
  })),
});

export const scanToOrder = (r: ScanResult): OrderDraft => ({
  supplier_id: r.match.supplier_id,
  reference: r.document.document_number,
  expected_at: r.document.delivery_date,
  document_key: r.document_key,
  lines: r.match.lines.map((l) => ({
    supplier_item_id: l.supplier_item_id,
    stock_item_id: l.stock_item_id,
    description: l.description,
    supplier_code: l.supplier_code,
    quantity: l.quantity,
    unit: l.unit ?? "",
    unit_price: Number(l.unit_price.toFixed(4)),
  })),
});
